"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _GroupedProduct = require("./GroupedProduct");
Object.keys(_GroupedProduct).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _GroupedProduct[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _GroupedProduct[key];
    }
  });
});
